import { put, call } from 'redux-saga/effects'
import axios from 'axios'
import { AUTH_INFO } from '../actions/types'
import { URL } from '../URL'
import { history } from '../../react/history'
import { APIECO_KEY, HOST } from './../Keys'
import { successMsg, errorMsg } from './../actions/alertMessageActions'
import { setAuthInfo } from '../actions/authActions';

/**
 * Login Worker
 * @param {type, payload}
 */
export function* loginWorker({ payload }) {

    try {
        // const { data } = yield call(login, payload)

        // console.log( data )
        // yield put(setAuthInfo(data))
        const sampleData = {
            auth_token: '...',
            refresh_token: '...',
            username: 'test@mail.com',
            fullname: 'علیرضا لواسانی',
            email: 'test@mail.com',
            roles: [],
            permissions: []
        }

        localStorage.setItem('authInfo', JSON.stringify(sampleData))
        history.push('/dashboard')
    }
    catch (error) {
        yield put(errorMsg('بروز خطا در ورود به سایت'))
        console.log(error)
    }

}

function login(data) {
    return axios({
        url: `${URL}/auth/login`,
        method: 'POST',
        data,
        headers: {
            apieco_key: APIECO_KEY,
        }
    })
}


/**
 * Register Worker
 * @param {action, payload}
 */
export function* registerWorker({ payload }) {

    try {
        // const { data } = yield call(register, payload)

        // console.log( data )

        yield put(successMsg('ثبت نام با موفقیت انجام شد'))
        // yield put(setAuthInfo(data))
        const sampleData = {
            auth_token: '...',
            refresh_token: '...',
            username: payload.email,
            fullname: payload.name,
            email: payload.email,
            roles: [],
            permissions: []
        }

        localStorage.setItem('authInfo', JSON.stringify(sampleData))
        history.push('/dashboard')
    }
    catch (error) {
        yield put(errorMsg('بروز خطا در ثبت نام'))
        console.log(error)
    }

}

function register(data) {
    return axios({
        url: `${URL}/auth/register`,
        method: 'POST',
        data,
        headers: {
            apieco_key: APIECO_KEY,
        }
    })
}